const fonts = {
  small: '1.rem',
  normal: '1.6rem',
  medium: '2.0rem',
  big: '2.6rem',
  huge: '4.2rem',
};

export default fonts;
